function GetSizeOfColor(params) {

    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetSizeOfColors",
        data: params,
        success: function (data) {

            $basketButton.parents(".AddToCartArea").find(".ProductListSizeContainer").html(data);
            var $firstSize = $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").find(".ProductListSize.active:first");

            var firstSizeId = ($firstSize.length > 0 ? $firstSize.attr("data-size") : 0);

            $basketButton.removeClass("passive");

            if (firstSizeId === 0) {
                $basketButton.addClass("passive");

                if ($("#SmallLangCode").val() === "tr") {
                    $basketButton.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-right-top-padding soldOutBadge' style='z-index:1'><img src='/images/BSL/badge/tukendi.png'></div>");

                }
                else if ($("#SmallLangCode").val() === "en") {
                    $basketButton.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding soldOutBadge'><img src='/images/BSL/badge/sold_out.png'></div>");
                }
                else if ($("#SmallLangCode").val() === "fr") {
                    $basketButton.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding soldOutBadge'><img src='/images/BSL/badge/epuise.png'></div>");
                }
            }

            $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").find(".ProductListSize").removeClass("active");
            $basketButton.parents(".AddToCartArea").children(".TransformContainer").addClass("select-size");
        },
        error: function () {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu.", "İşlem Başarısız", "Kapat");
        }
    });
}

function GetImageOfColors(params, item_unique_id, $currentColor) {

    var lazyImage = "/Images/BSL/lazy_back_new.jpg";

    Prd = $("#Prd" + item_unique_id);

    Prd.addClass("loading");

    var unique_id = item_unique_id.replace("#", "");

    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetImageOfColors",
        data: params,
        success: function (data) {

            $Crs = $("#Crs_" + item_unique_id);

            $Crs.find("div.carousel-inner").html("");

            var urlNew = "/";

            if (data.ProductUrl != undefined && data.ColorUrl != undefined) {
                urlNew += $("#SmallLangCode").val() + "/" + data.ColorName + "-" + data.ProductUrl + data.ColorUrl;
            }

            if (data.ProductVideoUrl != undefined && data.ProductVideoUrl != null) {

                //alert("video var");

                var $video = $('<video id="' + unique_id + '" class="video-detail" muted="muted" loop="" data-autoplay="" playsinline="playsinline" autoplay="" src="' + data.ProductVideoUrl + '"></video>');

                $currentColor.closest(".Prd").addClass("PrdItemBox");

                //$Crs.html($video);

                $video.appendTo($Crs.find("div.carousel-inner"));

                $Crs.find(".carousel-control").removeClass("carousel-control");

                //StartProductVideoFoProductList();
            }
            else {
                //alert("video yok");

                if (data.ImageItems != null && data.ImageItems.length > 0) {
                    for (var i = 0; i < data.ImageItems.length; i++) {
                        var imgJpg = data.ImageItems[i].ImagePath;
                        var imgWebp = data.ImageItems[i].ImagePathWebp;

                        var ImageItem = "<div class='carousel-item " + (i == 0 ? "active" : "") + "'><a href='" + urlNew + "'><picture>";

                        if (imgWebp != null) {
                            ImageItem += "<source data-srcset='" + imgWebp + "' type='image/webp' />";
                            ImageItem += "<img class='PImage img-responsive' src='" + imgWebp + "' />";
                        } else {
                            ImageItem += "<source data-srcset='" + imgJpg + "' type='image/jpeg' />";
                            ImageItem += "<img class='PImage img-responsive' src='" + imgJpg + "' />";
                        }

                        ImageItem += "</picture></a></div>";

                        $Crs.find("div.carousel-inner").append(ImageItem);
                    }
                }


                $Crs.find(".left").addClass("carousel-control");
                $Crs.find(".right").addClass("carousel-control");
            }

            //AddToCart attributeleri değiştir
            $currentColor.closest(".Prd").find(".AddToCart").attr("data-colorid", data.ColorID);
            $currentColor.closest(".Prd").find(".AddToCart").attr("data-productid", data.ProductID);
            $currentColor.closest(".Prd").find(".AddToCart").attr("data-sizeid", data.SizeID);

            //sistemde tanımlı badgeler varsa eklenmeli.
            if (data.BadgeImagePath != null && data.BadgeImagePath != undefined && data.BadgeTur != 14) {
                $currentColor.closest(".Prd").find(".ProductBadge").html("");

                if (data.BadgeTur == 7) {
                    $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-right-top-padding"><img src="' + data.BadgeImagePath + '" /></div>');
                } else if (data.BadgeTur == 8) {
                    $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-left-top-padding"><img src="' + data.BadgeImagePath + '" /></div>');
                } else if (data.BadgeTur == 9) {
                    $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-right-bottom-padding"><img src="' + data.BadgeImagePath + '" /></div>');
                } else if (data.BadgeTur == 10) {
                    $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-left-bottom-padding"><img src="' + data.BadgeImagePath + '" /></div>');
                }

                if (data.Amount < data.AmountOld) {
                    if ($("#SmallLangCode").val() === "tr") {
                        $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-right-top-padding'><img src='/images/BSL/badge/indirim_bagde.png'></div>");
                    }
                    else if ($("#SmallLangCode").val() === "en") {
                        $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-right-top-padding'><img src='/images/BSL/badge/discount_badge.png'></div>");
                    }
                    else if ($("#SmallLangCode").val() === "fr") {
                        $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-right-top-padding'><img src='/images/BSL/badge/rabais_badge.png'></div>");
                    }
                }
            }

            if (data.TotalQuantity <= 0) {
                $currentColor.closest(".Prd").find(".AddToCart").addClass("passive");
                if ($("#SmallLangCode").val() === "tr") {
                    $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-right-top-padding soldOutBadge' style='z-index:1'><img src='/images/BSL/badge/tukendi.png'></div>");
                }
                else if ($("#SmallLangCode").val() === "en") {
                    $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding soldOutBadge'><img src='/images/BSL/badge/sold_out.png'></div>");
                }
                else if ($("#SmallLangCode").val() === "fr") {
                    $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding soldOutBadge'><img src='/images/BSL/badge/epuise.png'></div>");
                }
            }
            else {
                $currentColor.closest(".Prd").find(".AddToCart").removeClass("passive");
                $currentColor.closest(".Prd").find(".ProductBadge").find(".soldOutBadge").remove();
            }

            Prd.find("img.PImage.img1").Lazy();

            Prd.removeClass("loading");
        },
        error: function (xhr, status, error) {
            var data = xhr.responseText;
            var jsonResponse = JSON.parse(data);
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu.", "İşlem Başarısız", "Kapat");
            Prd.removeClass("loading");
        }
    });
}

function IsfollowForProductDetails() {

    var ProductID = $("#PID").val();
    var AName = $("#AName").val();
    var CName = $("#CName").val();

    $That = $(".AddToFavorite");

    if (ProductID != undefined && ProductID != null && ProductID != "" && ProductID > 0 && AName == "Index" && CName == "ProductDetails") {
        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/IsFollow",
            data: 'ProductID=' + ProductID,
            dataType: 'json',
            async: true,
            success: function (dt) {
                if (dt.IsFollow == true) {
                    $That.removeClass("passiveFavorite");
                    $That.addClass("activeFavorite");
                    $That.find(".sorsfont").removeClass("sorsfont-follow").addClass("sorsfont-added-follow");
                } else {
                    $That.addClass("passiveFavorite");
                    $That.removeClass("activeFavorite");
                }
            }
        });
    }
}

function GetProductInstalments(Amount) {
    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetInstallmentOptions?Amount=" + Amount.replace(".", ""),
        success: function (data) {
            $(".InstallmentBody").html(data);
            $("#TaksitSecenekleri").modal();
            $('html, body').animate({
                scrollTop: $("#PdInstallmentOptionsDetail").offset().top - 50
            }, 500);
        }
    });
}

function GetProductWarn(data) {
    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/StokWarn",
        data: data,
        success: function (data) {
            if (data != "0" && data != 0) {

                var prdCls = "More";

                $(".LastProducts").removeClass("One");
                $(".LastProducts").removeClass("Two");
                $(".LastProducts").removeClass("More");
                $(".LastProducts").removeClass("Limited");

                $(".LastX").html(data);
                $(".LastPrdHint").html($(".LastPrdHint"));

                switch (data) {
                    case "1": prdCls = "One"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-one")); break;
                    case "2": prdCls = "Two"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-twotree")); break;
                    case "3": prdCls = "Two"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-twotree")); break;
                    case "": prdCls = "gizli"; $(".LastPrdHint").html(""); break;
                    case "4": prdCls = "Limited"; break;
                }

                $(".LastProducts").addClass(prdCls);

                // LastProducts elementini active olan bedene taşı
                var sizeOptions = $(".SizeOptions");
                sizeOptions.find(".active").append($(".LastProducts"));

                $(".LastProducts").show();
            }
        }
    });
}

function ChangeProductColor(ProductID, ColorID, LangID, button) {
    var params = "ProductID=" + ProductID + "&ColorID=" + ColorID + "&LangID=" + LangID;
    var say = 0;

    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/getProductDetailAjax",
        data: params,
        async: true,
        cache: false,
        success: function (data) {
            $.each(data, function (k, v) {
                if (say === 0) {

                    ChangeColorGetSize(ColorID, ProductID);

                    if ($("#SmallLangCode").val() == "tr") {
                        //$(".Colors .Name").html(v.ColorName);
                        $(".ProductHeader").html(v.ColorName + " " + v.ProductName);
                        document.title = v.ColorName + " " + v.ProductName + " | BSL";
                        $(".Prices .PrdouctCode span").html(v.ProductCode);
                        $(".PriceContainer .PriceOld").html(v.CurrencySymbol + " " + v.AmountOld);
                        $(".PriceContainer .Price ").html(v.CurrencySymbol + " " + v.Amount);
                        $("#aciklama .FabricDescription").html(v.FabricDescription);
                        $("#aciklama .ManikinDescription").html(v.ManikinDescription);
                    }
                    else {
                        //$(".Colors .Name").html(v.ColorLangName);
                        $(".ProductHeader").html(v.ColorLangName + " " + v.ProductName);
                        document.title = v.ColorLangName + " " + v.ProductName + " | BSL";
                        $(".Prices .PrdouctCode span").html(v.ProductCode);
                        $(".PriceContainer .PriceOld").html(v.CurrencySymbol + " " + v.AmountOld);
                        $(".PriceContainer .Price ").html(v.CurrencySymbol + " " + v.Amount);
                        $("#aciklama .FabricDescription").html(v.FabricDescription);
                        $("#aciklama .ManikinDescription").html(v.ManikinDescription);
                    }

                    $(".Colors .ColorOption .active").removeClass("active");
                    button.parent().addClass("active");
                    $(".AddToFavorite").attr("data-id", ProductID);

                    $("#PID").val(ProductID);
                    $("#ProductID").val(ProductID);
                    $("#ColorID").val(ColorID);
                }
                say++;
            });
        },
        error: function () {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu.", "İşlem Başarısız", "Kapat");
        }
    });
}

function ChangeColorGetSize(colorID, productID) {
    var params = "ColorID=" + colorID + "&ProductID=" + productID;
    var c = 0;
    var img = "";

    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetAllDetailInfoByColorID",
        data: params,
        success: function (data) {
            $selectSizePopup = $(".SizeOptions #SelectSizePopup");

            if ($selectSizePopup.length > 0) {
                $selectSizePopup = $(".SizeOptions #SelectSizePopup").clone();
            }

            $(".SizeOptions").html("");
            if ($selectSizePopup.length > 0) {
                $(".SizeOptions").append($selectSizePopup);
            }

            // GetNewColorImage
            var fotoSayisi = $(".ProductDetailImages ul li.ImgArea").length;

            $(".ProductDetailsMainImage > ul").slick('unslick');
            $(".ProductDetailsMainImage > ul > li").remove();

            if ($(window).width() > 991) {
                $(".SmallProductImages > ul").slick('unslick');
                $(".SmallProductImages > ul > li").remove();
            }

            $.each(data.reverse(), function (k, v) {
                if (v.Type == "StockImage") {
                    c++;

                    var selected = "";

                    if (c == 1) {
                        selected = " Selected ";
                    }

                    $(".ProductDetailsMainImage > ul").append('<li class="ImgArea fancybox ' + selected + '" href="' + v.Name.replace("_buyuk", "_enbuyuk") + '"><img src="' + v.Name.replace("_buyuk", "_enbuyuk") + '"  /></li>');

                    if ($(window).width() > 991) {
                        $(".SmallProductImages > ul").append('<li><img src="' + v.Name.replace("_buyuk", "_kucuk") + '" class="' + selected + '"  /></li>');
                    }
                }
                if (v.Type == "ProductVideo") {

                    c++;

                    var selected = "";

                    if (c == 1) {
                        selected = " Selected ";
                    }

                    $(".ProductDetailsMainImage > ul").append('<li class="ImgArea ' + selected + '" href="' + v.Name + '"><video muted loop="loop" id="video-product-detail" data-autoplay playsinline autoplay src="' + v.Name + '"  ></video></li>');

                    if ($(window).width() > 991) {
                        $(".SmallProductImages > ul").append('<li><img src="' + v.GifUrl + '" class="' + selected + '"  /></li>');
                    }
                }
            });

            //setTimeout(function () {
            SlickSlider(false);
            //}, 500);

            // GetNewColorSize
            var newSizeCount = 0;
            $(".SizeOptions").removeClass("passed");
            $("#SizeID").val("");
            $.each(data.reverse(), function (k, v) {
                if (v.Type == "Size") {
                    var stil = "";
                    if (v.InStock == false || v.PStatus != 1) {
                        stil = "OutOfQuantity";

                        if ($(".NewPD").length > 0) {
                            $(".SizeOptions").append('<span class="outer">' +
                                ' <input type="hidden" name="SizeIDs" id="SizeIDs" value="' + v.ID + '" >' +
                                ' <span class="PdHint"> <span class="PdHint-content"> ' +
                                '<a href="javascript:;" class="NotifyWhen">Stoğa Gelince Haber Ver<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z" /></svg></a>' +
                                ' </span></span>'
                                + '<span class="inner">' + v.Name + '</span></span>');
                        } else {
                            $(".SizeOptions").append('<span class="outer"><span class="inner">' + v.Name + '</span></span>');
                        }

                        $('.AddToRemindList').show();
                    }
                    else {
                        newSizeCount++;
                        $(".SizeOptions").append('<span class="selectSize"><a data-id="' + v.ID + '" data-stock="' + v.InStock + '" data-name="' + v.Name + '" href="javascript:void(0)" class="' + stil + " " + v.Name + '">' + v.Name + '</a></span>');
                    }
                }
            });

            if (newSizeCount == 0) {
                var badgeArea = "<div class='PDIConItem'><img src='/Images/BSL/badge/tukendi.png' alt='Bu ürün stoklarımızda tükenmiştir.'>";
                /*badgeArea += '<div class="text-tooltip hidden-xs hidden-sm"><span class="reactangle"></span><span class="text">Bu ürün stoklarımızda tükenmiştir.</span></div ></div>';*/

                $(".ProductContent .BadgeContainer").html(badgeArea);
            }
            else {
                $(".ProductContent .BadgeContainer").html("");
            }

            // GetNewColorSize
            if ($(".NewPD").length > 0) {
                $(".SizeOptions, .SizeAndAmount span.ChooseTitle").addClass("open");

                $(".Colors span.ChooseTitle").removeClass("current");
                $(".Colors span.ChooseTitle").addClass("passed");

                $(".SizeAndAmount span.ChooseTitle").addClass("current");
                $(".SizeAndAmount span.ChooseTitle").removeClass("passed");

                $(".AmountOptions span.ChooseTitle").removeClass("current");
                $(".AmountOptions span.ChooseTitle").removeClass("passed");

                $(".AmountOptions").removeClass("open");

                $(".Sizes").find(".Name").html("");

                $(".AddToBasket button").addClass("NotSelected");
                $(".AddCombineToBasket button").addClass("NotSelected");

                if ($(".AddToBasket button").attr("data-first") != undefined && $(".AddToBasket button").attr("data-first").length > 0) {
                    $(".AddToBasket button").text($(".AddToBasket button").attr("data-first"));
                }

                if ($(".AddCombineToBasket button").attr("data-first") != undefined && $(".AddCombineToBasket button").attr("data-first").length > 0) {
                    $(".AddCombineToBasket button").text($(".AddCombineToBasket button").attr("data-first"));
                }
            }

            //if (isMobile(true)) {
            //    $oldUl = $(".ProductDetailImages ul:first");
            //    $newul.insertAfter($(".ProductDetailImages ul:first"));
            //    $oldUl.remove();
            //}

            if ($(".SizeOptions .ONE.SIZE").length > 0) {
                $(".SizeOptions .ONE.SIZE").trigger("click");
                $(".SizeAndAmount").hide();
            }
            else {
                $(".SizeAndAmount").show();
            }
        },
        error: function () {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu.", "İşlem Başarısız", "Kapat");
        }
    });

}

function GetListForRemind(data) {
    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetListForRemind",
        data: data,
        cache: true,
        success: function (data) {

            $("#PrdBlackBg").hide();
            $(".SizeOptions.open").removeClass("PleaseSelect");
            $(".DropItems.PleaseSelect").removeClass("PleaseSelect");
            $(".AddToBasketOuther.PleaseSelect").removeClass("PleaseSelect");
            $("#RemindMeLater").addClass("active");

            if ($(".AutoTextRep").length > 0) {
                $(".AutoTextRep button").text($(".AutoTextRep button").attr("data-first"));
            }

            $("#NotifyModal").modal("show");
            $("#NotifyModal").css("display", "flex");

            $("#NotifyModal .modal-body").html(data);
            $(".NotifyColors a:first").trigger("click");

            if (data != null && data != "" && data != undefined) {
                if (data.length < 300) {
                    $("#NotifyModal .modal-footer button").hide();
                }
                else {
                    $("#NotifyModal .modal-footer button").show();
                }
            }
        }
    });
}

function RemindMeWhenAvailable(data) {
    $.ajax({
        type: "POST",
        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/RemindMeWhenAvailable",
        data: data,
        dataType: "json",
        success: function (dt) {
            if (dt.Sonuc == true) {
                $("#NotifyModal").modal("hide");
                SwalGenerate("success", dt.IslemSonucAciklama, "Talebini Aldık", "Kapat");
            }
            else {
                SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Tekrar Dene");
            }
        },
        error: function () {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu.", "İşlem Başarısız", "Tekrar Dene");
        }
    });
}

function AddToFavorite(ColorID, ProductID, callback) {

    var UserID = $("#UserID").val();

    $.ajax({
        type: 'get',
        url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToFollowList",
        data: 'colorID=' + ColorID + "&productID=" + ProductID,
        dataType: 'json',
        async: true,
        success: function (dt) {
            if (dt.Sonuc == true) {

                //RTB house script
                (rtbhEvents = window.rtbhEvents || []).push(
                    {
                        eventType: 'wishlist',
                        offerId: ''
                    },
                    {
                        eventType: 'uid',
                        id: UserID
                    }
                );

                $("#followcount").html('(' + dt.Deger2 + ')');

                callback(true, "Ürün favorilerinize eklenmiştir.");
            }
            else {
                callback(false, "Favorilere eklemek için giriş yapmalısınız.");
            }
        },
        error: function (httpObj, textStatus) {
            callback(false, "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!");
        }
    });

}

function removeFavorite(ProductID, callback) {
    $.ajax({
        type: 'get',
        url: "/" + $("#SmallLangCode").val() + "/p/Cart/RemoveFromList",
        data: 'id=' + ProductID + "&IsDetail=true",
        dataType: 'json',
        async: true,
        success: function (dt) {
            if (dt.Sonuc == true) {
                callback(true);
            }
            else {
                callback(false);
            }
        },
        error: function () {
            callback(false);
        }
    });
}

function ChangeCombineSliderPhoto(data) {
    GenerateLocalLoading($(".ProductDetailImages"), "show");
    GenerateLocalLoading($(".SmallProductImages"), "show");

    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetAllDetailInfoByColorID",
        data: data,
        success: function (data) {

            $(".ProductDetailImages > ul").slick('unslick');
            $(".ProductDetailImages > ul > li").remove();

            $(".SmallProductImages > ul").slick('unslick');
            $(".SmallProductImages > ul > li").remove();

            var c = 0;
            $.each(data.reverse(), function (k, v) {
                if (v.Type == "StockImage") {
                    c++;
                    var selected = "";
                    if (c == 1) {
                        selected = " Selected ";
                    }

                    $(".ProductDetailImages > ul").append('<li class="ImgArea fancybox ' + selected + '" href="' + v.Name.replace("_buyuk", "_enbuyuk") + '"><img src="' + v.Name.replace("_buyuk", "_enbuyuk") + '"  /></li>');

                    if ($(window).width() > 991) {
                        $(".SmallProductImages > ul").append('<li><img src="' + v.Name.replace("_buyuk", "_kucuk") + '" class="' + selected + '"  /></li>');
                    }
                }
            });

            SlickSlider(false);

            GenerateLocalLoading($(".ProductDetailImages"), "hide");
            GenerateLocalLoading($(".SmallProductImages"), "hide");
        },
        error: function () {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu.", "İşlem Başarısız", "Kapat");
            GenerateLocalLoading($(".ProductDetailImages"), "hide");
            GenerateLocalLoading($(".SmallProductImages"), "hide");
        }
    });
}